import axios, { AxiosError } from 'axios'
import type { ApiError } from '@sophia/shared-schemas'

const baseURL = (import.meta.env.VITE_API_URL ?? 'http://localhost:3001') + '/api/v1'

export const api = axios.create({
  baseURL,
  withCredentials: true,
  // NÃO setar Content-Type default — axios escolhe automaticamente:
  // application/json pra objetos, multipart/form-data com boundary pra FormData.
})

export interface NormalizedError {
  message: string
  code?: string
  status?: number
  fieldErrors?: Record<string, string[]>
}

export function extractApiError(err: unknown): NormalizedError {
  if (err instanceof AxiosError) {
    const data = err.response?.data as Partial<ApiError> | undefined
    return {
      message: data?.message ?? err.message ?? 'Erro inesperado',
      code: data?.code,
      status: err.response?.status,
      fieldErrors: data?.fieldErrors,
    }
  }
  if (err instanceof Error) return { message: err.message }
  return { message: 'Erro inesperado' }
}
